// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__12pQT","ranges":"BmiRanges_ranges__1f-Q_"};